import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: #181818;
  color: #fff;
  padding: 20px;
  text-align: center;

  .left-section {
    flex: 1;
    text-align: left;
  }
  
  .right-section {
    flex: 1;
    text-align: right;
  }
`;

export default FooterContainer;
